module.exports = __webpack_public_path__ + "img/KünstlerPrinzessin.b2f206da.svg";